import { useTranslation } from "react-i18next";
import { FormInput } from "@/shared/Components";
import { FieldLayout } from "@/pages/ContactsPage/Components/FieldLayout";
import type { FC } from "react";

type Props = {
  index: number;
  onBlur?: () => void;
  onChange?: () => void;
};

export const SocialNetworkField: FC<Props> = ({ index, onBlur, onChange }) => {
  const { t } = useTranslation();

  const handleBlur = () => {
    onBlur?.();
  };

  return (
    <FieldLayout direction="row">
      <FormInput
        name={`socialNetworks.${index}.socialNetworkType.name`}
        placeholder={t("contactsPage.generalInfo.type")}
        onBlur={handleBlur}
        customOnChange={onChange}
      />
      <FormInput
        name={`socialNetworks.${index}.socialNetwork`}
        placeholder="@ username"
        onBlur={handleBlur}
      />
    </FieldLayout>
  );
};
